import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import type { LearningUiTranslator } from './learning-ui-copy'

export function useLearningUiTranslation(): LearningUiTranslator {
  const { t } = useTranslation('translation')

  return useCallback<LearningUiTranslator>(
    (label, values = {}) => t(`learningUi.${label}`, { defaultValue: label, ...values }),
    [t],
  )
}
